import React from "react";
import * as styles from "./rules-editor-card-icon.module.scss";
import { StyleableIcon } from "../../../helper/icon-helper";
import { classArr } from "../../../helper/style-helper";

export interface RulesEditorCardIconProps {
	className?: string;
	backgroundColor: string;
	foregroundColor: string;
	icon: StyleableIcon;
}

/**
 * An icon displayed in the header of a major card
 */
export default function RulesEditorCardIcon(props: RulesEditorCardIconProps) {
	return (
		<div
			className={classArr(props.className, styles.container)}
			style={{ backgroundColor: props.backgroundColor }}
		>
			{props.icon?.(24, props.foregroundColor)}
		</div>
	);
}
